import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Popover, Image } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { EXCLUSIVE_LABELS } from './constants';

const StyledWrapper = styled.section`
  margin: 26px 0;
  ${(props) => props.theme.typo.familyGoogle.medium};

  .desc {
    font-size: 18px;
  }
  .primary {
    font-size: 14px;
    color: ${(props) => props.theme.color.primaryBase};

    @media only screen and (min-width: ${(props) => props.theme.metrics.breakpoints.sm}) {
      font-size: 18px;
    }
  }

  .sub {
    font-size: 14px;
    color: #7a7a7b;

    @media only screen and (min-width: ${(props) => props.theme.metrics.breakpoints.sm}) {
      font-size: 18px;
    }
  }

  .infoIcon {
    color: #7a7a7b;
  }

  @media only screen and (max-width: 767px) {
    margin: 10px 0;
  }
`;

const StyledExclusivePopover = styled.div`
  padding: 12px 8px;
`;

const StyledCardWrapper = styled.ul`
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding: 0 6px 12px 6px;
  margin: 0 -6px -12px -6px;
  margin-top: 20px;
  list-style: none;

  .card-item {
    flex: 0 0 auto;
  }
`;

const StyledCard = styled.article`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 7px;
  padding: 20px;
  border-radius: 12px;
  width: 285px;
  height: 170px;
  box-shadow: 0px 6px 8px rgba(161, 161, 161, 0.25);
  background-color: ${(props) => props.theme.color.background};

  .name {
    ${(props) => props.theme.typo.familyGoogle.semiBold};
    ${(props) => props.theme.typo.style.header};
    color: ${(props) => props.theme.color.primaryBase};
    line-height: 22px;
    margin-bottom: 7px;
  }

  .desc {
    ${(props) => props.theme.typo.familyGoogle.regular};
    ${(props) => props.theme.typo.style.captionRegular};
`;

const ExclusiveLabels = () => {
  const { t } = useTranslation();
  const { desc, tooltip } = EXCLUSIVE_LABELS;
  return (
    <StyledWrapper role="region" aria-label="Exclusive Labels">
      <header>
        <Trans
          className="desc"
          i18nKey={desc}
          components={{ primary: <span className="primary" />, sub: <span className="sub" /> }}
        />
        <Popover
          placement="bottom"
          content={
            <StyledExclusivePopover>
              <Trans i18nKey={tooltip} components={{ br: <br /> }} />
            </StyledExclusivePopover>
          }
          overlayInnerStyle={{ borderRadius: 12 }}
        >
          <InfoCircleOutlined className="infoIcon" aria-label="More information about exclusive labels" />
        </Popover>
      </header>
      <StyledCardWrapper role="list" aria-label="Exclusive label cards">
        {EXCLUSIVE_LABELS.labels.map((label) => (
          <StyledCard
            className="card-item"
            key={label.name}
            role="listitem"
            aria-label={`Exclusive label: ${label.name}`}
          >
            <Image
              src={label.image}
              alt={`${label.name} icon`}
              width={25}
              height={25}
              preview={false}
              aria-hidden="true"
            />
            <h3 className="name">
              <Trans i18nKey={label.name} components={{ br: <br /> }} />
            </h3>
            <p className="desc">
              <Trans i18nKey={label.description} components={{ br: <br /> }} />
            </p>
          </StyledCard>
        ))}
      </StyledCardWrapper>
    </StyledWrapper>
  );
};

export default ExclusiveLabels;
